<!--
  render list as carousel since the list contains more then 3 items
-->
<ng-template #carousel>
  <div class="card-carousel">
    <ngu-carousel #cardListCarousel [inputs]="tileConfig" [dataSource]="source">
      <ngu-tile *nguCarouselDef="let item; let i = index">
        <ng-container [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{item: item}">
        </ng-container>
      </ngu-tile>

      <div NguCarouselPrev class="slide-left d-none d-md-flex" *ngIf="!cardListCarousel.isFirst">&lt;</div>
      <div NguCarouselNext class="slide-right d-none d-md-flex" *ngIf="!cardListCarousel.isLast">&gt;</div>
    </ngu-carousel>

    <ul class="quick-nav" NguCarouselPoint>
        <li *ngFor="let pointNumber of cardListCarousel.pointNumbers;"
            [class.active]="pointNumber === cardListCarousel.activePoint"
            (click)="cardListCarousel.moveTo(pointNumber)">
        </li>
    </ul>
  </div>
</ng-template>

<!--
  render given list but since this contains less then 3 items this is no carousel
-->
<ng-template #list>
  <div class="card-list">
    <div class="item-wrapper" *ngFor="let item of source">
      <ng-container [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{item: item}">
      </ng-container>
    </div>
  </div>
</ng-template>

<!--
  render carousel if we got more then 3 items otherwise simple flex container which centers the items
-->
<ng-container *ngTemplateOutlet="source.length > 3 || isMobile ? carousel : list"></ng-container>
